import { Inline } from '@shared/layout/Inline'
import { FC, useMemo } from 'react'
import { MusclesLabels } from '@ui/MusclesLabels'
import DumbbellArm from '@images/exerciseIcons/dumbbell-arm.jpg'
import { MuscleLabelInfo, MuscleService } from '@entities/muscle'
import { ShadowBlock } from '@/shared/layout/ShadowBlock'

interface CardProps {
	img?: string
	title: string
	muscle_group_codes: string[]
	onClick: (title: string) => void
}

export const Card: FC<CardProps> = ({ muscle_group_codes, img, title, onClick }) => {
	const muscleGroups = useMemo(() => {
		const muscleCodes = MuscleService.getGroupCodesFromMuscleCodes(muscle_group_codes)

		const musclesInfo: MuscleLabelInfo[] = muscleCodes.map(code => {
			return MuscleService.getMuscleLabelInfo(code)
		})

		return musclesInfo
	}, [muscle_group_codes])

	return (
		<ShadowBlock type='bottom'>
			<div
				onClick={() => onClick(title)}
				style={{
					overflowX: 'hidden',
					borderRadius: 15,
					background: 'white',
					width: '100%',
				}}>
				<Inline
					gap={14}
					align={'center'}
					style={{
						overflowX: 'hidden',
						padding: '16px 12px',
						maxWidth: '100%',
					}}>
					<img src={img || DumbbellArm} alt={title} width={60} height={60} />
					<div style={{ overflowX: 'scroll', flexShrink: 0, maxWidth: '80%' }}>
						<div style={{ fontSize: 16, fontWeight: 500 }}>{title}</div>
						<MusclesLabels
							style={{
								marginTop: 15,
								overflowX: 'scroll',
								scrollbarWidth: 'none',
							}}
							muscleGroups={muscleGroups}
							itemStyle={{
								padding: '4px 11px',
								height: 23,
								color: 'white',
								fontSize: 12,
								minWidth: 'auto',
								whiteSpace: 'nowrap',
								marginTop: 0,
							}}
						/>
					</div>
				</Inline>
			</div>
		</ShadowBlock>
	)
}
